import { dataEye } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEye = /*#__PURE__*/createIcon(dataEye)
export default IconEye
